exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".details_box .header_box[data-v-72e8381f]{width:100%;height:63px;background:#e7efff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 20px}.details_box .header_box .name_span[data-v-72e8381f]{margin-left:30px;font-weight:600;font-size:18px;color:#474245}.details_box .title_type[data-v-72e8381f]{width:90px;height:44px;background:#eef4ff;color:#282828;border-radius:4px;font-weight:600;font-size:14px;margin-right:10px;cursor:pointer}.details_box .select_title_style[data-v-72e8381f]{background:#66b1ff;color:#fff}", ""]);

// exports
